<template>
  <div style="width: 100%">
    <v-tabs v-model="tab" class="tab-event">
      <v-tabs-slider color="#3be287"></v-tabs-slider>
      <v-tab v-for="item in tabItems" :key="item">{{ item }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in tabItems" :key="item">
        <v-container v-if="item === 'info'" class="card-container-info">
          <v-row style="margin-top: 10px">
            <v-col cols="3.5"
              ><v-row
                ><p class="info-data">Event type :&nbsp;</p>
                <p class="value-data"></p>
                Maneuver</v-row
              >
              <v-row
                ><p class="info-data">
                  {{
                    getLabelWithUnitFromPath(
                      ['inclinationChange'],
                      'AbstractEvent'
                    )
                  }}
                  :&nbsp;
                </p>
                <p class="value-data">
                  {{
                    getDisplayValueFromPath(
                      maneuverInfoEvent.inclinationChange,
                      ['inclinationChange'],
                      'AbstractEvent'
                    )
                  }}
                </p></v-row
              ></v-col
            >
            <v-divider vertical></v-divider>
            <v-col cols="5"
              ><v-row
                ><p class="info-data">
                  {{
                    getLabelWithUnitFromPath(
                      ['detectionDate'],
                      'AbstractEvent'
                    )
                  }}:&nbsp;
                </p>
                <p class="value-data">
                  {{
                    getDisplayValueFromPath(
                      maneuverInfoEvent.detectionDate,
                      ['detectionDate'],
                      'AbstractEvent'
                    )
                  }}
                </p></v-row
              >
              <v-row
                ><p class="info-data">
                  {{
                    getLabelWithUnitFromPath(
                      ['semiMajorAxisChange'],
                      'AbstractEvent'
                    )
                  }}
                  :&nbsp;
                </p>
                <p class="value-data">
                  {{
                    getDisplayValueFromPath(
                      maneuverInfoEvent.semiMajorAxisChange,
                      ['semiMajorAxisChange'],
                      'AbstractEvent'
                    )
                  }}
                </p></v-row
              ></v-col
            >
            <v-divider vertical></v-divider>
            <v-col cols="3.5"
              ><v-row>
                <p class="info-data">
                  {{
                    getLabelWithUnitFromPath(
                      ['eventTargetNoradId'],
                      'AbstractEvent'
                    )
                  }}:&nbsp;
                </p>
                <p class="value-data"></p>
                {{
                  getDisplayValueFromPath(
                    maneuverInfoEvent.eventTargetNoradId,
                    ['eventTargetNoradId'],
                    'AbstractEvent'
                  )
                }}</v-row
              >
              <v-row>
                <p class="info-data">
                  {{
                    getLabelWithUnitFromPath(
                      ['eccentricityChange'],
                      'AbstractEvent'
                    )
                  }}
                  :&nbsp;
                </p>
                <p class="value-data"></p>
                {{
                  getDisplayValueFromPath(
                    maneuverInfoEvent.eccentricityChange,
                    ['eccentricityChange'],
                    'AbstractEvent'
                  )
                }}</v-row
              ></v-col
            >
          </v-row>
          <v-row style="margin-top: 20px"
            ><v-col
              ><v-row>
                <p class="info-data">
                  {{
                    getLabelWithUnitFromPathFieldDescription(
                      ['deltaVThresholdOnSma'],
                      'AbstractAlertDefinition'
                    )
                  }}
                  :&nbsp;
                </p>
                <p class="value-data">
                  {{
                    getDisplayValueFromPathFieldDescription(
                      getDeltaVOnSma,
                      ['deltaVThresholdOnSma'],
                      'AbstractAlertDefinition'
                    )
                  }}
                </p></v-row
              ></v-col
            >
            <v-col
              ><v-row>
                <p class="info-data">
                  {{
                    getLabelWithUnitFromPathFieldDescription(
                      ['deltaVThresholdOnInc'],
                      'AbstractAlertDefinition'
                    )
                  }}
                  :&nbsp;
                </p>
                <p class="value-data">
                  {{
                    getDisplayValueFromPathFieldDescription(
                      getDeltaVOnInc,
                      ['deltaVThresholdOnInc'],
                      'AbstractAlertDefinition'
                    )
                  }}
                </p></v-row
              ></v-col
            ></v-row
          >
          <v-row>
            <v-col>
              <span class="text-h6">Last TLE before the maneuver</span>
              <TLEDecoder
                :tle="
                  maneuverInfoEvent.precedingTle
                    .split('\n')
                    .map((line) => line.trim())
                "
                :isExpanded="false"
                :expandDisabled="false"
                :textboxReadonly="true"
              ></TLEDecoder>
            </v-col>
            <v-col>
              <span class="text-h6">TLEs of the maneuver</span>
              <v-textarea
                v-model="getFollowingTles"
                readonly
                style="font-family: monospace"
                full-width
                outlined
                rows="3"
                class="mb-n7"
              ></v-textarea>
            </v-col> </v-row
        ></v-container>
        <v-container v-if="item === 'graph'" class="card-container-info">
          <v-row>
            <ScreeningCatalogueAnalysisPlotsOrbitParameters
              :tles="eventTles"
              :maneuverDates="maneuverDates"
              :idMission="idMission"
              :idSatellite="maneuverInfoEvent.eventTargetNoradId"
            />
          </v-row> </v-container></v-tab-item
    ></v-tabs-items>
  </div>
</template>

<script>
import ScreeningCatalogueAnalysisPlotsOrbitParameters from './ScreeningCatalogueAnalysisPlotsOrbitParameters.vue'

import * as Cesium from 'cesium'
import TLEDecoder from '../../components/Toolbox/TLEDecoder'
import ScreeningCatalogueAnalysisEventsCesiumVisualizer from './ScreeningCatalogueAnalysisEventsCesiumVisualizer.vue'
import defense from '../../mixins/defense'
import { mapGetters } from 'vuex'
export default {
  name: 'ScreeningCatalogueAnalysisEventsManeuverVisualizer',
  props: {
    maneuverInfoEvent: { type: Object },

    idMission: {
      type: String
    }
  },

  components: {
    ScreeningCatalogueAnalysisPlotsOrbitParameters,
    ScreeningCatalogueAnalysisEventsCesiumVisualizer,
    TLEDecoder
  },
  mixins: [defense],
  data() {
    return {
      dialog: false,
      satellitesDatas: [],
      timelineDates: [],
      textDescription:
        'The display of a maneuver event is based on the data points corresponding to the position of the space object before and during the maneuver. The first point, which is the last point before the maneuver, is propagated until the end date of the maneuver, therefore showing the original trajectory of the space object. The other points, corresponding to the position of the space object during the maneuver, are propagated from one point to the following one, hence showing the new trajectory of the space object during and after the maneuver has happened.',
      tabItems: ['info', 'graph'],
      tab: null
    }
  },
  watch: {
    maneuverInfoEvent() {
      this.updateDatas()
    }
  },
  computed: {
    ...mapGetters({
      currentResultsLog: 'currentResultsLog'
    }),
    maneuverDates() {
      return [
        {
          legendText: 'Maneuver event',
          dates: [
            [
              this.maneuverInfoEvent.previousTLEDate,
              this.maneuverInfoEvent.lastFollowingTleDate
            ]
          ],
          color: ' #0000ff ',
          opacity: 0.4
        },
        {
          legendText: this.getLabelFromPath(
            ['firstFollowingTleDate'],
            'AbstractEvent'
          ),
          dates: [this.maneuverInfoEvent.firstFollowingTleDate],

          color: '#af1216 ',
          opacity: 1
        }
      ]
    },
    getDeltaVOnSma() {
      for (const alert of this.currentResultsLog.results.analysisResult
        .alertDefinitions) {
        if (alert.id === this.maneuverInfoEvent.alertId) {
          return alert.deltaVThresholdOnSma
        }
      }
    },
    getDeltaVOnInc() {
      for (const alert of this.currentResultsLog.results.analysisResult
        .alertDefinitions) {
        if (alert.id === this.maneuverInfoEvent.alertId) {
          return alert.deltaVThresholdOnInc
        }
      }
    },
    getFollowingTles() {
      return this.maneuverInfoEvent.followingTles.join('\n')
    },
    eventTles() {
      return [this.maneuverInfoEvent.precedingTle].concat(
        this.maneuverInfoEvent.followingTles
      )
    }
  },
  mounted() {
    this.updateDatas()
  },
  methods: {
    async updateDatas() {
      this.satellitesDatas = []
      this.timelineDates = []
      const startDate = this.maneuverInfoEvent.previousTLEDate
      const endDate = this.maneuverInfoEvent.lastFollowingTleDate
      this.satellitesDatas = await this.getDataTwoSatellites({
        firstName: 'TargetBefore',
        secondName: 'TargetAfter',
        firstColor: Cesium.Color.GREEN,
        secondColor: Cesium.Color.RED,
        firstTles: [this.maneuverInfoEvent.precedingTle],
        secondTles: this.maneuverInfoEvent.followingTles,
        startDate: startDate,
        endDate: endDate,
        firstOrbitLine: true,
        secondOrbitLine: true,
        firstPlanes: null,
        secondPlanes: null
      })

      this.timelineDates.push({
        color: 'blue',
        tooltip: 'Start Date',
        date: startDate
      })
      this.timelineDates.push({
        color: 'red',
        tooltip: 'Date first detection maneuver',
        date: this.maneuverInfoEvent.firstFollowingTleDate
      })
      this.timelineDates.push({
        color: 'blue',
        tooltip: 'End Date',
        date: endDate
      })
      this.sendDatasForCesium({
        satellitesDatas: this.satellitesDatas,
        timelineDates: this.timelineDates,
        textDescription: this.textDescription
      })
    },
    sendDatasForCesium(item) {
      this.$emit('cesium-visualizer-method', item)
    }
  }
}
</script>
<style scoped>
.info-data {
  font-weight: bold;
  margin-left: 15px;
}
.card-container-info {
  height: 475px;
  overflow-y: scroll;
  scrollbar-width: none;
}
</style>
